export default __webpack_public_path__ + "static/map-6245d7d05d3f8a01657a5a2582ea593d.png";